import { Link } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";
export function SectionAction({
  to,
  params,
  label,
}: {
  to: string;
  params: Record<string, string>;
  label: string;
}) {
  return (
    <Link
      to={to}
      params={params}
      className="text-muted-foreground hover:text-foreground inline-flex items-center gap-1 text-xs transition-colors"
    >
      {label}
      <ChevronRight className="h-4 w-4" />
    </Link>
  );
}
